module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0143.jpg?v=a1d9b042";